var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row content-box full-height"},[_c('wrapper',[_c('agent-bot-form',{attrs:{"form-type":"view"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }